import api from './api';

/**
 * Astrologer Service
 * Handles all astrologer-related API calls
 */

const astrologerService = {
  /**
   * Get all astrologers with optional filters
   * @param {Object} filters - Query filters (specialization, online, etc.)
   * @returns {Promise} List of astrologers
   */
  getAstrologers: (filters = {}) => {
    return api.get('/astrologers', { params: filters });
  },

  /**
   * Get online astrologers only
   * @returns {Promise} List of online astrologers
   */
  getOnlineAstrologers: () => {
    return api.get('/astrologers', { params: { online: true } });
  },

  /**
   * Get specific astrologer details
   * @param {number} id - Astrologer ID
   * @returns {Promise} Astrologer details
   */
  getAstrologer: (id) => {
    return api.get(`/astrologers/${id}`);
  },

  /**
   * Get astrologer's availability for tomorrow
   * @param {number} id - Astrologer ID
   * @returns {Promise} Availability data
   */
  getAvailability: (id) => {
    return api.get(`/astrologers/${id}/availability/tomorrow`);
  },

  /**
   * Rate an astrologer after consultation
   * @param {number} id - Astrologer ID
   * @param {number} rating - Rating value (1-5)
   * @param {string} feedback - Optional feedback text
   * @returns {Promise} Rating confirmation
   */
  rateAstrologer: (id, rating, feedback = '') => {
    return api.post(`/astrologers/${id}/rate`, { rating, feedback });
  }
};

export default astrologerService;
